import React, { useEffect, useState } from 'react';
import { Paper, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Chip, Skeleton, Box } from '@mui/material';
import { People } from '@mui/icons-material';
import { dashboardAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function TopActiveUsersWidget({ days = 30, limit = 8 }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { load(); }, [days]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = async () => {
    try {
      const res = await dashboardAPI.getTopActiveUsers({ days, limit });
      setData(res.data.data || []);
    } catch (err) {
      console.error('TopActiveUsers load error', err);
      setData([]);
    }
  };

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Top Active Users ({days}d)</Typography>
      {!data ? (
        <Box>
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} height={40} sx={{ mb: 1 }} />
          ))}
        </Box>
      ) : data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No activity yet</Typography>
      ) : (
        <List>
          {data.map((u) => (
            <ListItem key={u.userId} button onClick={() => navigate(`/dashboard/users/${u.userId}/analytics`)}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: '#7C3AED' }}>{u.name?.[0]?.toUpperCase() || '?'}</Avatar>
              </ListItemAvatar>
              <ListItemText primary={u.name || u.email || 'Unknown'} secondary={u.email} />
              <Chip label={`${u.sessions} sessions`} size="small" />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}
